import {Component, inject, input} from '@angular/core';
import {MatListModule} from '@angular/material/list';
import {MatIconModule} from '@angular/material/icon';
import {RouterLink, RouterLinkActive} from '@angular/router';
import {MatDividerModule} from '@angular/material/divider';
import {Store} from '@ngrx/store';
import {selectSelectedProject} from '../../service/project.selectors';
import {MatButtonModule} from '@angular/material/button';
import {ClickEventService} from '../../../../utils/services/click-event.service';
import {ProjectPermissionService} from '../../../../utils/services/project-permission.service';

@Component({
  selector: 'app-project-side-nav',
  imports: [
    MatIconModule,
    RouterLink,
    MatDividerModule,
    RouterLinkActive,
    MatButtonModule,
    MatListModule
  ],
  templateUrl: './project-side-nav.component.html',
  styleUrl: './project-side-nav.component.scss'
})
export class ProjectSideNavComponent {
  readonly projectPermissionService: ProjectPermissionService = inject(ProjectPermissionService);
  private readonly store: Store = inject(Store);
  private readonly clickEventService: ClickEventService = inject(ClickEventService);

  readonly isMobile = input.required<boolean>();
  readonly project = this.store.selectSignal(selectSelectedProject);


  onSettingClick() {
    this.clickEventService.emitClickSettingEvent();
  }

  onNavigate() {
    if (this.isMobile()) {
      this.clickEventService.emitClickSideNavEvent();
    }
  }


}
